import docApi from '@/views/page/doctor/api_url'
import nurseApi from '@/views/page/nurse/nurse_api_url'
import drugApi from '@/views/page/drug/drug_api_url'
import chargeApi from '@/views/page/toll/script/charge-api'
import treatmentApi from '@/views/page/technician/script/treatment-api'
import inpatientApi from '@/views/page/live-toll/live-toll-api'
import mineApi from '@/views/page/mine/mine_url'
// 随访
import aiFollowUpApi from '@/views/page/AI-follow-up/script/ai-follow-up-api'

const systemApi = {
  login: '/system-api/webapi/user/login',
  userLogout: '/system-api/webapi/user/logout',
  changePassword: '/system-api/webapi/user/change-password',
  getEntity: '/system-api/webapi/hospital/get-entity',
  // 切换角色
  changeDefaultRole: '/system-api/webapi/user/change-default-role',
  // 获取当前医院
  getCurrentHospital: '/system-api/webapi/hospital/get-current-hospital',
  getHospitalLevel: '/system-api/webapi/dictionary/get-list?table=hospital_level',
  hospitalUpdate: '/system-api/webapi/hospital/update',
  getTree: '/system-api/webapi/specialties-catalog/get-tree',
  departmentGetTree: '/system-api/webapi/department/get-tree',
  specialtiesCatalogGetTree: '/system-api/webapi/specialties-catalog/get-tree',
  departmentInsert: '/system-api/webapi/department/insert',
  departmentGetEntity: '/system-api/webapi/department/get-entity',
  departmentDelete: '/system-api/webapi/department/delete',
  departmentUpdate: '/system-api/webapi/department/update',
  getAreaList: '/gfd-information/get-area-list',
  getContractList: '/gfd-contract/get-contract-list',
  userListAll: '/system-api/webapi/user/list-all',
  // 不使用科室列出用户，用条件列出用户
  // userListAllDepartment: '/system-api/webapi/user/list-users-by-department',
  userListUsesDepartment: '/system-api/webapi/user/list-users',
  userDelete: '/system-api/webapi/user/delete',
  userUpdate: '/system-api/webapi/user/update',
  userInsert: '/system-api/webapi/user/register-as-doctor',
  resetUserPassword: '/system-api/webapi/user/reset-password',
  treatmentInsert: '/system-api/webapi/treatment-info/insert',
  CareerType: '/system-api/webapi/dictionary/get-list?table=career_type',
  medicineInsert: '/system-api/webapi/medicine-info/insert',
  dictionaryTitle: '/system-api/webapi/dictionary/get-list',
  roleInsert: '/system-api/webapi/role/insert',
  roleListAll: '/system-api/webapi/role/list-all',
  roleDelete: '/system-api/webapi/role/delete',
  roleUpdate: '/system-api/webapi/role/update',
  roleListRoles: '/system-api/webapi/role/list-search',
  listChapter: '/system-api/webapi/dd-icd10-hospital/list-chapter',
  icd10Insert: '/system-api/webapi/dd-icd10-hospital/insert',
  icd10ListIcd10s: '/system-api/webapi/dd-icd10-hospital/list-icd10s',
  icd10Delete: '/system-api/webapi/dd-icd10-hospital/delete',
  icd10Update: '/system-api/webapi/dd-icd10-hospital/update',
  icd9ListIcd9Cm3s: '/system-api/webapi/ddIcd9Cm3Hospital/listSearch',
  icd9Insert: '/system-api/webapi/ddIcd9Cm3Hospital/insert',
  icd9Update: '/system-api/webapi/ddIcd9Cm3Hospital/update',
  icd9Delete: '/system-api/webapi/ddIcd9Cm3Hospital/delete',
  searchcommon: '/system-api/webapi/dictionary/search-common',
  deleteCommon: '/system-api/webapi/dictionary/delete-common',
  updateCommon: '/system-api/webapi/dictionary/update-common',
  insertCommon: '/system-api/webapi/dictionary/insert-common',
  roleId: '/system-api/webapi/power/list-role-by-user-id',
  roleAuthorize: '/system-api/webapi/power/authorize-role-to-user',
  rolePower: '/system-api/webapi/power/list-power-by-role-id',
  roleFunction: '/system-api/webapi/power/authorize-power-function-to-role',
  updateHospital: '/system-api/webapi/specialties-catalog/update-hospital-catalog',
  costGetTree: '/system-api/webapi/dd-cost-category/list-search',
  delTreeItem: '/system-api/webapi/dd-cost-category/delete',
  modTreeItem: '/system-api/webapi/dd-cost-category/update',
  addTreeItem: '/system-api/webapi/dd-cost-category/insert',
  tableListSearch: '/system-api/webapi/dd-treatment-medicine-insurance/list-search',
  mainTableListSearch: '/system-api/webapi/treatment-info/list-search',
  mainTableListSearchDetail: '/system-api/webapi/treatment-info/get',
  mainTableListUpdate: '/system-api/webapi/treatment-info/update',
  mainTableListDelete: '/system-api/webapi/treatment-info/delete',
  deptList: '/system-api/webapi/department/list-clinical-laboratory',
  dictionaryWithCondition: '/system-api/webapi/dictionary/search-common',
  testDetail: '/system-api/webapi/treatment-info-item/list-search',
  medicineTableList: '/system-api/webapi/dd-medicine-insurance/list-search',
  mediRightTableSearch: '/system-api/webapi/medicine-info/list-search',
  mediRightTableSearchDetail: '/system-api/webapi/medicine-info/get',
  mediRightTableUpdate: '/system-api/webapi/medicine-info/update',
  mediRightTableDelete: '/system-api/webapi/medicine-info/delete',
  medHcCateDelete: '/system-api/webapi/dd-medicine-insurance/delete',
  medHcCateAdd: '/system-api/webapi/dd-medicine-insurance/insert',
  medHcCateModify: '/system-api/webapi/dd-medicine-insurance/update',
  treatHcCateDelete: '/system-api/webapi/dd-treatment-medicine-insurance/delete',
  treatHcCateAdd: '/system-api/webapi/dd-treatment-medicine-insurance/insert',
  treatHcCateModify: '/system-api/webapi/dd-treatment-medicine-insurance/update',
  treatLeftSearch: '/system-api/webapi/treatment-group-info/list-tree',
  treatLeftAdd: '/system-api/webapi/treatment-group-info/insert',
  treatLeftModify: '/system-api/webapi/treatment-group-info/update',
  treatLeftDelete: '/system-api/webapi/treatment-group-info/delete',
  treatRightSearch: '/system-api/webapi/treatment-group-relation/list-search',
  treatRightDelete: '/system-api/webapi/treatment-group-relation/delete',
  treatRightAdd: '/system-api/webapi/treatment-group-relation/insert',
  treatRightEdit: '/system-api/webapi/treatment-group-relation/update',
  insertReceiptType: '/system-api/webapi/dd-receipt-type/insert',
  updateReceiptType: '/system-api/webapi/dd-receipt-type/update',
  deleteReceiptType: '/system-api/webapi/dd-receipt-type/delete',
  getReceiptType: '/system-api/webapi/dd-receipt-type/list-search',
  insertTreatmentGroupCategory: '/system-api/webapi/dd-treatment-group-category/insert',
  updateTreatmentGroupCategory: '/system-api/webapi/dd-treatment-group-category/update',
  deleteTreatmentGroupCategory: '/system-api/webapi/dd-treatment-group-category/delete',
  getTreatmentGroupCategory: '/system-api/webapi/dd-treatment-group-category/list-search',
  listSearch: '/system-api/webapi/patient/list-search',
  insertPatient: '/system-api/webapi/patient/insert',
  systemApiUpdatePatient: '/system-api/webapi/patient/update',
  getPatient: '/system-api/webapi/patient/get',
  getByCode: '/system-api/webapi/biConfig/getByCode'
}

const requestApi = Object.assign(systemApi, docApi, nurseApi, drugApi, chargeApi, treatmentApi, mineApi, inpatientApi, aiFollowUpApi)

export default requestApi
